import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=05b7818b&"
import script from "./ReportTable.vue?vue&type=script&lang=ts&"
export * from "./ReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=05b7818b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports